/**
 * Performs a hard refresh of the current page with no-cache headers to ensure fresh content.
 * See: https://stackoverflow.com/questions/29246444/fetch-how-do-you-make-a-non-cached-request
 * for more details.
 *
 * @param url - The URL to refresh (defaults to current location)
 */
export const hardRefresh = async (
  url: string = window.location.href,
): Promise<void> => {
  // First, fetch the page with no-cache headers to ensure we get fresh content
  await fetch(url, {
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      Expires: '0',
    },
  })

  // Force reload the page
  window.location.href = url
  window.location.reload()
}
